"use client"
import axiosInstance from '@/lib/axiosInstance';
import { setCookie } from '@/lib/cookies';
import { AxiosError } from 'axios';
import Link from 'next/link'
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { useOrgLogo } from '@/hooks/useOrgLogo';
// var cookie = require('cookie');

// import { cookies } from 'next/headers'


type ErrorObject = {
    [key: string]: string
}


export default function Page() {
    const router = useRouter();
    const [message, setMessage] = useState<string | null>(null);
    const { logo: orgLogo, isLoading: logoLoading } = useOrgLogo();
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    // Function to get the expiration date for 6 months from now
    function getExpirationDate(months: number): string {
        const date = new Date();
        date.setMonth(date.getMonth() + months);
        return date.toUTCString();
    }
    useEffect(() => {
        // Access URL parameters using URLSearchParams
        const params = new URLSearchParams(window.location.search);
        const m = params.get('m');
        if (m) {
            setMessage(m);
            // Optionally, clear the query parameter from the URL after displaying the message
            router.push('/login'); // This will remove the query parameter
        }
    }, [router]);

    const [errors, setErrors] = useState<ErrorObject>({});
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsSubmit(true);

        let errorObject: ErrorObject = {};

        try {
            let response = await axiosInstance.post('api/users/forgot-password', formData);
            let forgotEmail = response?.data?.data?.email;
            let resetOtp = response?.data?.data?.otp;
            let status = response?.data?.status;

            if (status === 200) {
                Cookies.set('forgotEmail', forgotEmail);
                Cookies.set('resetOtp', resetOtp);
                router.push('/otp-verify');
            } else {
                // Handle structured error in response (not in catch block)
                const errorArray = response?.data?.error;
                if (Array.isArray(errorArray)) {
                    errorObject = errorArray.reduce((acc: any, cur: any) => {
                        if (cur.field && cur.message) {
                            acc[cur.field] = cur.message;
                        }
                        return acc;
                    }, {});
                    setErrors(errorObject);
                }
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                const errorArray = error?.response?.data?.error;
                if (Array.isArray(errorArray)) {
                    errorObject = errorArray.reduce((acc: any, cur: any) => {
                        if (cur.field && cur.message) {
                            acc[cur.field] = cur.message;
                        }
                        return acc;
                    }, {});
                } else if (typeof error?.response?.data === 'object') {
                    errorObject = error.response.data;
                } else {
                    errorObject = { general: error?.response?.data };
                }
                setErrors(errorObject);
            }
        } finally {
            setIsSubmit(false);
        }
    };


    return (
        <div>
            <div className="top_bar flex gap-10 items-center justify-between pr-3 md:pr-10 py-2 shadow-custom1">
                <div>
                    <Link href={"/"}>
                        {logoLoading ? (
                            <div className="md:max-w-[450px] h-12 flex items-center justify-center">
                                <svg 
                                    className="animate-spin h-8 w-8 text-gray-400" 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    fill="none" 
                                    viewBox="0 0 24 24"
                                >
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        ) : (
                            <img 
                                className="md:max-w-[450px]" 
                                src={orgLogo} 
                                alt="hart-college-logo"
                                onError={(e: any) => {
                                    e.target.src = "/images/hart-clg-new-logo.png";
                                }}
                            />
                        )}
                    </Link>
                </div>
                <nav className="flex md:gap-3 items-center flex-col md:flex-row">
                    <span className="underline text-xs md:text-sm text-nowrap">Don&apos;t have an account?</span>
                    <Link href={"/signup"} className="text-lg font-medium cursor-pointer">Signup</Link>
                </nav>
            </div>
            <div className="container border md:mt-14 rounded-md md:pt-10 pb-14">
                <h2 className="text-3xl font-playfair mt-5">Forgot Password</h2>
                <hr className="my-3" />

                {message && <div className="p-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
                    Verification complete now you reset password with your otp
                </div>}

                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 py-5 gap-x-5 gap-y-4">
                        <div>
                            <label htmlFor="email">
                                Email:
                            </label>
                            <input className="border rounded-sm py-2 px-2 outline-none w-full block" type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                required
                                onChange={handleChange}
                            />
                            {errors?.email && <p className='text-red-500'>{errors.email}</p>}
                        </div>
                    </div>
                    <div>
                        {/* <button className="capitalize mt-4 py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] text-white tracking-wider" disabled={isSubmit}> 
                            { isSubmit ? 'Log In...' :'Log In' }
                        </button> */}

                        <button
                            className="capitalize mt-4 py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] text-white tracking-wider"
                            disabled={isSubmit}
                        >
                            {isSubmit ? (
                                <div className="flex items-center justify-center">
                                    <svg
                                        className="animate-spin h-5 w-5 mr-2 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 0 1 8-8v2a6 6 0 0 0-6 6h-2z"
                                        />
                                    </svg>
                                    {`Sending Email...`}
                                </div>
                            ) : 'Send Email'}
                        </button>

                    </div>
                </form>
            </div>
        </div >
    )
}